module.exports = __webpack_public_path__ + "media/images/homepage-bg-11b47f99c7d6cd5ac6c343a410c3804b.jpg";